import type { Route } from '../../routes/types';
import { Confirmacion } from './Confirmacion';
import { MiCuenta } from './MiCuenta';
import { MisTurnos } from './MisTurnos';
import { Pago } from './Pago';
import { Reprogramar } from './Reprogramar';
import { Resena } from './Resena';
import { Reservar } from './Reservar';
import { TurnoDePaciente } from './TurnoDePaciente';
import './paciente.css';

const soloPacientes = { roles: ['paciente' as const], layout: 'publico' as const };

export const routes: Route[] = [
  { path: '/reservar/:id', title: 'Reservar turno', screen: Reservar, ...soloPacientes },
  { path: '/pago', title: 'Pagar la seña', screen: Pago, ...soloPacientes },
  { path: '/confirmacion/:id', title: 'Turno reservado', screen: Confirmacion, ...soloPacientes },
  { path: '/mis-turnos', title: 'Mis turnos', screen: MisTurnos, ...soloPacientes },
  { path: '/turno/:id', title: 'Detalle del turno', screen: TurnoDePaciente, ...soloPacientes },
  { path: '/reprogramar/:id', title: 'Reprogramar turno', screen: Reprogramar, ...soloPacientes },
  { path: '/resena/:id', title: 'Dejar reseña', screen: Resena, ...soloPacientes },
  { path: '/mi-cuenta', title: 'Mi cuenta', screen: MiCuenta, ...soloPacientes },
];
